import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var RefreshLineArrowSvg = function RefreshLineArrowSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M20.485 20.485A12 12 0 0 1 12 24c-3.167 0-5.51-.877-7.333-2.218A12.4 12.4 0 0 1 3 20.294V22H0v-7h7v3H4.967a9.6 9.6 0 0 0 1.48 1.366C7.726 20.309 9.44 21 12 21a9 9 0 0 0 9-9h3a12 12 0 0 1-3.515 8.485M21 3.707V2h3v7h-7V6h2.033a9.6 9.6 0 0 0-1.48-1.366C16.274 3.691 14.56 3 12 3a9 9 0 0 0-9 9H0A12 12 0 0 1 12 0c3.167 0 5.51.877 7.333 2.218.622.458 1.173.963 1.667 1.489",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  }))));
};
export var RefreshLineArrow = function RefreshLineArrow(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: RefreshLineArrowSvg
  }));
};